import {createAction} from "lib/actions/";

export const ERROR_FATAL     = "APP/ERROR_FATAL";
export const ERROR_WARNING   = "APP/ERROR_WARNING";

export const RELOAD = "APP/RELOAD";

export const MAIN_MENU_OPEN  = "APP/MAIN_MENU_OPEN";
export const MAIN_MENU_CLOSE = "APP/MAIN_MENU_CLOSE";

export const SET_USER_IDENTITY = "APP/SET_USER_IDENTITY";

// Async actions
export const FETCH_AVAILABLE_PRODUCTS          = "APP/FETCH_AVAILABLE_PRODUCTS";
export const FETCH_AVAILABLE_PRODUCTS_COMPLETE = "APP/FETCH_AVAILABLE_PRODUCTS_COMPLETE";

export const PRODUCT_SAGAS_ATTACHED            = "APP/PRODUCT_SAGAS_ATTACHED";

export const OPEN_URL = "APP/OPEN_URL";
export const OPEN_EMAIL = "APP/OPEN_EMAIL";
export const OPEN_PHONE = "APP/OPEN_PHONE";
export const FORCE_REGISTRATION = "APP/FORCE_REGISTRATION";

export const PROCESS_METADATA = "APP/PROCESS_METADATA";
export const GO_BACK = "APP/GO_BACK";
export const CLOSE_APPLICATION = "APP/CLOSE_APPLICATION";
export const CLEAR_CLIENT_INIT_DATE = "APP/UPDATE_CLIENT_INIT_DATE";
export const CLOSE_DOWN_TIME_REPORTER = "APP/CLOSE_DOWN_TIME_REPORTER";
export const PROCESS_GOOGLE_PAY_RESPONSE = "APP/PROCESS_GOOGLE_PAY_RESPONSE";
export const CLOSE_CUSTOMER_NOTICES_FRAME = "APP/CLOSE_CUSTOMER_NOTICES_FRAME";
export const MARK_CUSTOMER_NOTICE_AS_READ = "APP/MARK_CUSTOMER_NOTICE_AS_READ";

export const OPEN_INFORMATION_MODAL = "APP/OPEN_INFORMATION_MODAL";
export const CLOSE_INFORMATION_MODAL = "APP/CLOSE_INFORMATION_MODAL";

export const OPEN_LOADING_FRAME = "APP/OPEN_LOADING_FRAME";
export const CLOSE_LOADING_FRAME = "APP/CLOSE_LOADING_FRAME";

// Action Creators

export function reload() {
  return createAction(RELOAD);
}

export function fatalError(error) {
  return createAction(ERROR_FATAL, true, {error} );
}
export function warningError(error) {
  return createAction(ERROR_WARNING, true, { error });
}
export function openAppMenu() {
  return createAction(MAIN_MENU_OPEN);
}
export function closeAppMenu() {
  return createAction(MAIN_MENU_CLOSE);
}

export function fetchAvailableProducts() {
  return createAction(FETCH_AVAILABLE_PRODUCTS)
}

export function fetchAvailableProductsSuccess(payload) {
  return createAction(FETCH_AVAILABLE_PRODUCTS_COMPLETE, false, payload);
}
export function fetchAvailableProductsFail(payload) {
  return createAction(FETCH_AVAILABLE_PRODUCTS_COMPLETE, true, payload);
}

export function productSagasAttached() {
  return createAction(PRODUCT_SAGAS_ATTACHED);
}

export function setUserIdentity(userIdentity){
  return createAction(SET_USER_IDENTITY, false, userIdentity);
}
export function setUserIdentityFailed(userIdentity){
  return createAction(SET_USER_IDENTITY, true);
}

export function openEmail(emailAddress) {
  return createAction(OPEN_EMAIL, false, {emailAddress} );
}
export function openPhone(phoneNumber) {
  return createAction(OPEN_PHONE, false, {phoneNumber} );
}
export function openURL(url) {
  return createAction(OPEN_URL, false, {url} );
}
export function forceRegistration(userMessage) {
  return createAction(FORCE_REGISTRATION, false, {userMessage} );
}

export function processMetadata(metadata) {
  return createAction(PROCESS_METADATA, false, {metadata} );
}

export function goBack(location) {
  return createAction(GO_BACK, false, {...location});
}

export function closeApplication() {
  return createAction(CLOSE_APPLICATION, false);
}

export function clearClientInitDate() {
  return createAction(CLEAR_CLIENT_INIT_DATE, false);
}

export function closeDownTimeReporter() {
  return createAction(CLOSE_DOWN_TIME_REPORTER, false);
}

export function processGooglePayResponse(response) {
  return createAction(PROCESS_GOOGLE_PAY_RESPONSE, false, {response} );
}

export function closeCustomerNoticeFrame() {
  return createAction(CLOSE_CUSTOMER_NOTICES_FRAME, false);
}

export function markCustomerNoticeAsRead() {
  return createAction(MARK_CUSTOMER_NOTICE_AS_READ, false);
}

export function openInformationModal(informationDetails) {
  return createAction(OPEN_INFORMATION_MODAL, false, {informationDetails});
}

export function closeInformationModal() {
  return createAction(CLOSE_INFORMATION_MODAL, false);
}

export function openLoadingFrame() {
  return createAction(OPEN_LOADING_FRAME, false);
}

export function closeLoadingFrame() {
  return createAction(CLOSE_LOADING_FRAME, false);
}



// WEBPACK FOOTER //
// ./src/state/app/actions.js